module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/cosmicpvp.b2d47950.png";